const empty_name = "This field is required"
const empty_email = "This field is required"
const invalid_email = "Invalid email"
const empty_message = "This field is required"

const name_errors = {
  empty: "This field is required"
}

const email_errors = {
  empty: "This field is required",
  invalid: "Invalid email"
}

const message_errors = {
  empty: "This field is required"
}


export {
  name_errors,
  email_errors,
  message_errors
}



// WEBPACK FOOTER //
// ./src/contact/form/error_messages.js